import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import ArticlePage from "@/pages/ArticlePage";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Articles } from "@/components/Articles";
import { About } from "@/components/About";
import { Advantages } from "@/components/Advantages";
import { Catalog } from "@/components/Catalog";
import { Calculator } from "@/components/Calculator";
import { Testimonials } from "@/components/Testimonials";
import { SeoSection } from "@/components/SeoSection";
import { LocationSection } from "@/components/LocationSection";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -84 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);
};

function App() {
  useLenis();
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const onNav = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onNav);
    window.addEventListener("app:navigate", onNav);
    return () => {
      window.removeEventListener("popstate", onNav);
      window.removeEventListener("app:navigate", onNav);
    };
  }, []);
  const articleMatch = path.match(/^\/artikel\/([a-zA-Z0-9-]+)/);
  if (articleMatch) {
    return (
      <ThemeProvider>
        <ArticlePage slug={articleMatch[1]} />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider>
      <div className="App min-h-screen" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Articles />
          <About />
          <Advantages />
          <Catalog />
          <Calculator />
          <Testimonials />
          <SeoSection />
          <LocationSection />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </ThemeProvider>
  );
}

export default App;
